import moment from 'moment'
import { CustomerTypeModel } from './customer-type'

// voucher status
export const SALE_ORDER_STATUS_JUST_PLACED = 1
export const SALE_ORDER_STATUS_APPROVED = 2
export const SALE_ORDER_STATUS_CANCELLED = 3
// export const SALE_ORDER_STATUS_POSTED = 3;

export const SALE_ORDER_STATUS_NAME = {
  1: 'Just Placed',
  2: 'Approved',
  3: 'Cancelled',
  // 3: 'Posted',
}

export const SALE_ORDER_STATUS_DROPDOWN_OPTIONS = [
  {
    value: SALE_ORDER_STATUS_JUST_PLACED,
    label: SALE_ORDER_STATUS_NAME[SALE_ORDER_STATUS_JUST_PLACED],
  },
  { value: SALE_ORDER_STATUS_APPROVED, label: SALE_ORDER_STATUS_NAME[SALE_ORDER_STATUS_APPROVED] },
  // { value: SALE_ORDER_STATUS_POSTED, label: SALE_ORDER_STATUS_NAME[STATUS_POSTED] },
  {
    value: SALE_ORDER_STATUS_CANCELLED,
    label: SALE_ORDER_STATUS_NAME[SALE_ORDER_STATUS_CANCELLED],
  },
]

export const SALE_ORDER_CURRENCY_SYMBOL = 'PKR'
export const SALE_ORDER_QUANTITY_ROUND_DECIMAL_PLACE = 3
export const SALE_ORDER_AMOUNT_ROUND_DECIMAL_PLACE = 3

export const ENABLE_ROUNDING_YES = 1
export const ENABLE_ROUNDING_No = 2

export const SCRAP_SALE_YES = 1
export const SCRAP_SALE_NO = 0

export const STATE_PROVINCE_BALOCHISTAN = 2
export const STATE_PROVINCE_AJK = 4
export const STATE_PROVINCE_CAPITAL_TERRITORY = 5
export const STATE_PROVINCE_KPK = 6
export const STATE_PROVINCE_PUNJAB = 7
export const STATE_PROVINCE_SINDH = 8
export const STATE_PROVINCE_GILGIT_BALTISTAN = 9

export const STATE_PROVINCE_NAMES = {
  2: 'BALOCHISTAN',
  4: 'AZAD JAMMU AND KASHMIR',
  5: 'CAPITAL TERRITORY',
  6: 'KHYBER PAKHTUNKHWA',
  7: 'PUNJAB',
  8: 'SINDH',
  9: 'GILGIT BALTISTAN',
}

export const STATE_PROVINCE_DROPDOWN_OPTIONS = [
  { value: STATE_PROVINCE_BALOCHISTAN, label: STATE_PROVINCE_NAMES[STATE_PROVINCE_BALOCHISTAN] },
  { value: STATE_PROVINCE_AJK, label: STATE_PROVINCE_NAMES[STATE_PROVINCE_AJK] },
  {
    value: STATE_PROVINCE_CAPITAL_TERRITORY,
    label: STATE_PROVINCE_NAMES[STATE_PROVINCE_CAPITAL_TERRITORY],
  },
  { value: STATE_PROVINCE_KPK, label: STATE_PROVINCE_NAMES[STATE_PROVINCE_KPK] },
  { value: STATE_PROVINCE_PUNJAB, label: STATE_PROVINCE_NAMES[STATE_PROVINCE_PUNJAB] },
  { value: STATE_PROVINCE_SINDH, label: STATE_PROVINCE_NAMES[STATE_PROVINCE_SINDH] },
  {
    value: STATE_PROVINCE_GILGIT_BALTISTAN,
    label: STATE_PROVINCE_NAMES[STATE_PROVINCE_GILGIT_BALTISTAN],
  },
]

export const SaleOrderModel = {
  id: 0,
  code: 'Auto Generated',
  branch_id: 0,
  department_id: null,
  department: { name: '' },
  branch: { name: '' },
  party_id: null,
  party: { name: '' },
  revenue_account_id: null,
  revenue_account: { name: '' },
  tax_head_id: null,
  tax_head: { name: '', rate: 0 },
  project_id: null,
  project: { name: '' },
  customer_po_date: '',
  sod_date: moment().format('YYYY-MM-DD'),
  contact_person: '',
  additional_details: '',
  expected_delivery_date: '',
  customer_po_no: '',
  other_erp_sod_no: '',
  remarks: '',
  status: SALE_ORDER_STATUS_JUST_PLACED,
  approved_at: '',
  approved_by_id: null,
  approved_by: { name: '' },
  created_by_id: 0,
  created_by: { name: '' },
  created_at: '',
  updated_by_id: 0,
  updated_by: { name: '' },
  updated_at: '',
  sale_order_details: [],
  attachements: [],
  advance_received: 0,
  additional_tax_rate: 0,
  additional_tax_amount: 0,
  customer_type_id: null,
  customer_type: { ...CustomerTypeModel },
  enable_rounding: ENABLE_ROUNDING_YES,
  income_tax_head_id: null,
  income_tax_head: { name: '', rate: 0 },
  income_tax_head_rate: 0,
  income_tax_head_amount: 0,
  scrap_sale: SCRAP_SALE_NO,
  retail_customer: 0,
  retail_customer_name: null,
  retail_customer_cnic: null,
  state: null,
}
